import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApplicationState } from '@/state/root.models'
import { FormStatusType } from '@/enums/form-status.enum'

import { BonusesFilters } from '../models'
import initialState from './initial-state'
import createBonusEngineExtraReducer from '../thunks/create.thunk'

import deleteBonusEngineExtraReducer from '../thunks/delete.thunk'
import getAllGamesByProviderExtraReducer from '../thunks/get-all-games.thunk'
import getAllBonusesExtraReducer from '../thunks/get-all.thunk'

import getOneBonusExtraReducer from '../thunks/get-bonus.thunk'
import getProviderCategoriesExtraReducer from '../thunks/get-provider-categories.thunk'
import getProvidersExtraReducer from '../thunks/get-providers.thunk'

import updateBonusEngineExtraReducer from '../thunks/update.thunk'
import getAllBonusesByBundleExtraReducer from '../thunks/get-bonuses-by-bundle.thunk'

const bonusEngineSlice = createSlice({
  name: 'bonus-engine',
  initialState,
  reducers: {
    setIsloadingAction: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    resetCurrentBonusAction: (state, action: PayloadAction<undefined>) => {
      state.currentBonus = { ...initialState.currentBonus }
    },
    setBonusFormModeAction: (state, action: PayloadAction<FormStatusType>) => {
      state.bonusFormMode = action.payload
    },
    setBonusesFiltersAction: (state, action: PayloadAction<BonusesFilters>) => {
      state.filters = action.payload
    },
    bonusEngineFailureAction: (state, action: PayloadAction<Error | any>) => {
      state.isLoading = false
      state.hasError = true
      state.error = action.payload
    },
  },
  extraReducers: (builder) => {
    createBonusEngineExtraReducer(builder)
    deleteBonusEngineExtraReducer(builder)
    getAllGamesByProviderExtraReducer(builder)
    getAllBonusesExtraReducer(builder)
    getOneBonusExtraReducer(builder)
    getProviderCategoriesExtraReducer(builder)
    getProvidersExtraReducer(builder)
    updateBonusEngineExtraReducer(builder)
    getAllBonusesByBundleExtraReducer(builder)
  },
})

export const {
  resetCurrentBonusAction,
  setBonusFormModeAction,
  setBonusesFiltersAction,
  bonusEngineFailureAction,
} = bonusEngineSlice.actions

export const BonusEngineActions = bonusEngineSlice.actions

export const bonusEngineSelector = ({ bonusEngine }: ApplicationState) =>
  bonusEngine

export default bonusEngineSlice
